import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent {
  showLogAnalyticsQuery: boolean = false;

  constructor(private readonly router: Router) {}

  navigateToAlertsBreakdown(): void {
    this.router.navigate(['/alerts-breakdown']);
  }
}
